import React from 'react'
import { HorizontalVideoSpotlight } from '../style'

//* utils
import { ASSETS } from '../../../../constants/assets'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import Button from '../../button'
import GlobalContainer from '../../globalContainer'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import { renderVideoSection } from './videoSection'

export const renderHeadline = (
  videoSpotlightData: any,
  isFeaturedVideo: boolean,
  isHorizontal: boolean
) => {
  if (isFeaturedVideo) {
    return (
      <Typography className="FeaturedVideos__headline" type="bodyXS">
        {formatInlineCode(videoSpotlightData.headline)}
      </Typography>
    )
  }

  return (
    <Typography
      className={`VideoSpotlight__Headline ${
        isHorizontal ? 'VideoSpotlight__Headline-Horizontal' : ''
      }`}
      type="header3">
      {formatInlineCode(videoSpotlightData.headline)}
    </Typography>
  )
}

export const renderSubheadline = (videoSpotlightData: any, isHorizontal: boolean) => {
  if (isHorizontal) {
    return (
      <Typography className="VideoSpotlight__Subheadline" type="caption">
        {formatInlineCode(videoSpotlightData.subheadline)}
      </Typography>
    )
  } else {
    return (
      <Typography className="VideoSpotlight__Subheadline" type="lead">
        {formatInlineCode(videoSpotlightData.subheadline)}
      </Typography>
    )
  }
}

export const renderTopSection = (
  videoSpotlightData: any,
  isFeaturedVideo: boolean,
  isHorizontal: boolean
) => {
  return (
    <div className="VideoSpotlight__Content-Container">
      {videoSpotlightData.logo.url && (
        <div className="VideoSpotlight__Logo-Container">
          <WrapperImage
            src={ImgUtil.getResizedImageUrl(videoSpotlightData.logo.url, 'width=575')}
            loading="lazy"
            alt={videoSpotlightData.logo.altText}
            height={575}
            width={575}
            threshold={650}
          />
        </div>
      )}

      {videoSpotlightData.headline &&
        renderHeadline(videoSpotlightData, isFeaturedVideo, isHorizontal)}
      {videoSpotlightData.subheadline && renderSubheadline(videoSpotlightData, isHorizontal)}
    </div>
  )
}

export const renderCTA = (videoSpotlightData: any, isFeaturedVideo: any) => {
  const ctaHref = videoSpotlightData.cta?.internalLink
    ? internalLinkHandler(videoSpotlightData.cta?.internalLink)
    : videoSpotlightData.cta?.externalUrl

  return (
    <Button
      icon={true}
      href={ctaHref}
      text={videoSpotlightData.cta?.text}
      type={isFeaturedVideo ? 'tertiary' : 'text-link'}
      size="small"
      theme={isFeaturedVideo ? 'dark' : videoSpotlightData.theme.toLowerCase()}
    />
  )
}

export const renderHorizontalSpotlight = (
  videoSpotlightData: any,
  isFeaturedVideo: any,
  isHorizontal: boolean
) => {
  return (
    <GlobalContainer>
      <HorizontalVideoSpotlight data-cy="VideoSpotlight-Horizontal">
        {(videoSpotlightData.headline ||
          videoSpotlightData.subheadline ||
          videoSpotlightData.cta) && (
          <div className="VideoSpotlight__Horizontal-Text">
            {videoSpotlightData.subheadline && renderSubheadline(videoSpotlightData, isHorizontal)}

            {videoSpotlightData.headline &&
              renderHeadline(videoSpotlightData, isFeaturedVideo, isHorizontal)}

            {videoSpotlightData.body && (
              <div className="VideoSpotlight__Body">{renderRichText(videoSpotlightData.body)}</div>
            )}

            {videoSpotlightData.cta && renderCTA(videoSpotlightData, isFeaturedVideo)}
          </div>
        )}

        {(videoSpotlightData.video.id || videoSpotlightData.video.animationFile) &&
          renderVideoSection(videoSpotlightData, isFeaturedVideo, isHorizontal)}

        <div className="VideoSpotlight__Robot-Illustration">
          <WrapperImage
            alt="UiPath Robot Illustration"
            src={ImgUtil.getResizedImageUrl(ASSETS.TRANSPARENT_ROBOT, 'width=300')}
            width={300}
            height={300}
            threshold={650}
          />
        </div>
      </HorizontalVideoSpotlight>
    </GlobalContainer>
  )
}
